import nodes from './nodes';
import room from './room';
import members from './members';
import reports from './reports';
import faqs from './faqs';
import auth from './auth';
import questionsAndAnswers from './questions-and-answers';
import rfi from './rfi';
import rfiTemplates from './rfi/rfi-templates';
import archives from './archives';
import shareableLinks from './shareable-links';
import waitingRoom from './waiting-room';
import nda from './nda';
import termsAndConditions from './terms-and-conditions';
import desktopApp from './desktopApp';

export default {
  nodes,
  room,
  members,
  reports,
  questionsAndAnswers,
  faqs,
  auth,
  rfi,
  rfiTemplates,
  archives,
  shareableLinks,
  waitingRoom,
  nda,
  termsAndConditions,
  desktopApp,
};
